import React from "react";
import TradeBreakFilter from "./TradeBreakFilter";
import SidePanelLayout from "../../layouts/SidePanelLayout";
import TradeBreaksPanelWrapper from "./TradeBreaksPanelWrapper";


export default function TradeBreaks(){

    return(
        <SidePanelLayout
            sideComponent={TradeBreakFilter}
            mainComponent={TradeBreaksPanelWrapper}>
        </SidePanelLayout>
    );
}


